import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ErrorDisplay.css'; // We'll create this CSS file next

// Define the props for our ErrorDisplay component
interface ErrorDisplayProps {
  sectionTitle: string;
  errorMessage: React.ReactNode;    // Allows sring, JSX elements, etc.
  navButtonText?: string; // Optional: Text for the navigation button
  navButtonLink?: string; // Optional: Link for the navigation button
  icon?: React.ReactNode; // Optional: Custom icon
}

const DefaultErrorIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="error-icon-svg" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm1-8h-2V7h2v2z"/>
  </svg>
);

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  sectionTitle,
  errorMessage,
  navButtonText,
  navButtonLink,
  icon
}) => {
  const navigate = useNavigate();

  const handleNavButtonClick = () => {
    if (navButtonLink) {
      navigate(navButtonLink);
    }
  };

  return (
    <div className="error-display-container">
      <div className="error-display-card">
        <div className="error-display-icon-container">
          {icon || <DefaultErrorIcon />}
        </div>
        <h2 className="error-display-section-title">{sectionTitle}</h2>
        <p className="error-display-message">{errorMessage}</p>
        {navButtonText && navButtonLink && (
          <button
            onClick={handleNavButtonClick}
            className="error-display-nav-button deriq-action-button" // Reusing your existing button style
          >
            {navButtonText}
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorDisplay;
